Namespace 'Models'

class Models.UserProfileTag extends Backbone.Model
  defaults:
    description: ''
    account_setting_id: 0


Namespace 'Collections'
class Collections.UserProfileTagCollection extends Backbone.Collection
  url: '/keepcon/settings/user_profile_tags'
  model: Models.UserProfileTag

  parse: (response) ->
    response.tags
